import { useQuery } from '@apollo/client'
import { AccountInfo } from '@azure/msal-common'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { CircularProgress, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import Container from '../../common/container/Container'
import Page from '../../common/page/Page'
import { fetchMe } from '../auth/authQueries'
import authStore from '../auth/authStore'
import { User } from '../auth/types'
import { i18n } from '../index'

const UserProvider = observer(({ children }) => {
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const activeAccount = instance.getActiveAccount()
  const user = authStore.user
  const { data, loading } = useQuery<{ me: User }>(fetchMe, {
    skip: !shouldFetchUser(isAuthenticated, user, activeAccount),
    fetchPolicy: 'network-only',
  })

  if (data && data.me) {
    authStore.setUser(data.me)
  }

  if (loading) {
    return (
      <Page>
        <Container>
          <Typography variant='h4'>{i18n.t('common.loading')}</Typography>
          <CircularProgress />
        </Container>
      </Page>
    )
  }

  return <>{children}</>
})

function shouldFetchUser(isAuthenticated: boolean, user?: User | null, activeAccount?: AccountInfo | null): boolean {
  if (window.location.href.includes('kirjaudu')) {
    return false
  }
  if (!isAuthenticated) {
    return false
  }
  if (!user && activeAccount) {
    return true
  }
  if (activeAccount && user && user.id) {
    // This is here only for precaution in case the active user has changed and the previous user is still in the store
    const encodedUserId = user.id
    const decodedUserId = decodeUserId(encodedUserId)
    return activeAccount && decodedUserId !== activeAccount.localAccountId
  }
  return false
}

function decodeUserId(encodedUserId: string): string {
  let idArray: string[] = []
  try {
    idArray = atob(encodedUserId).split(':')
  } catch (e) {
    console.error('Failed to decode user id', e)
    return ''
  }
  return idArray.length === 2 ? idArray[1] : ''
}

export default UserProvider
